import { useSelector } from "react-redux";
import { LeftNavBar } from "../../SharedModule/components/LeftNavBar";
import { LeftNavBarSection } from "../../SharedModule/components/LeftNavBarSection";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import {
  ASSETS_ADMIN_ROLES,
  ROUTE_ASSETS,
  ASSETS_ALL_ROLES,
  ROUTE_HOME,
  ROUTE_ASSETS_MONTHLY_CHARGES_REPORT,
  ROUTE_ASSETS_CHANGES_LOG_REPORT,
} from "../../SharedModule/utils/constants";

export const LeftNavBarAsset = (props: any) => {
  const { userRolesList } = useSelector(selectUserRoles);

  return (
    <LeftNavBar>
      <LeftNavBarSection
        mainTitle="Assets"
        biIconName="BiLaptop"
        requireModuleAccess={true}
        roleRequired={ASSETS_ALL_ROLES}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "Asset List",
            route: ROUTE_ASSETS,
            requireModuleAccess: true,
            roleRequired: ASSETS_ALL_ROLES,
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Reports"
        biIconName="BiBarChartAlt2"
        roleRequired={ASSETS_ALL_ROLES}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "Monthly Charges by Cost Center",
            route: ROUTE_ASSETS_MONTHLY_CHARGES_REPORT,
            requireModuleAccess: true,
            roleRequired: ASSETS_ALL_ROLES,
          },
          {
            text: "Asset Change Log",
            route: ROUTE_ASSETS_CHANGES_LOG_REPORT,
            requireModuleAccess: true,
            roleRequired: ASSETS_ALL_ROLES,
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Administration"
        biIconName="BiShieldQuarter"
        requireModuleAccess={true}
        roleRequired={ASSETS_ADMIN_ROLES}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "Asset Classes",
            route: process.env.REACT_APP_APPSMITH_ASSETS_CLASSES_PAGE,
            requireModuleAccess: true,
            roleRequired: ASSETS_ADMIN_ROLES,
            newTab: true,
          },
          {
            text: "Asset Types",
            route: process.env.REACT_APP_APPSMITH_ASSETS_TYPES_PAGE,
            requireModuleAccess: true,
            roleRequired: ASSETS_ADMIN_ROLES,
            newTab: true,
          },
        ]}
      />
    </LeftNavBar>
  );
};
